module.exports = __webpack_public_path__ + "static/media/star-fha.c3d97f5b.png";